import React, { useEffect } from 'react';
import Head from 'next/head';
import setResponseHeaders from '@buzzfeed/headers';
import { useTrackingContext } from '../../hooks/useTrackingContext';
import { TrackingContext } from '../../context/TrackingContext';
import RatRaceLanding from '../../components/RatRaceLanding';
import {
  getRatRacePolicyBasePath,
  isJoinRatRaceHost,
} from '../../utils/ratRacePolicyBasePath';
import { CLUSTER } from '../../constants';

const PAGE_INFO = {
  context_page_type: 'utility',
  context_page_id: 'rat-race/landing',
  destination: 'buzzfeed',
  page_edition: 'en-us',
};

const TIME_SPENT_INFO = {
  ...PAGE_INFO,
  unit_type: 'component',
  unit_name: 'rat_race_landing',
};

function RatRacePageContent({ policyBasePath }) {
  const { trackPageview, attachTimeSpentHandler } = useTrackingContext();

  useEffect(() => {
    trackPageview(PAGE_INFO);
    attachTimeSpentHandler(TIME_SPENT_INFO);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Head>
        <title>Rat Race</title>
        <meta
          name="description"
          content="Rat Race landing page"
        />
      </Head>
      <RatRaceLanding policyBasePath={policyBasePath} />
    </>
  );
}

export async function getServerSideProps({ req, res }) {
  // Rat Race's canonical home is joinratrace.com; buzzfeed.com/ai-ui/rat-race
  // should send visitors there instead of rendering the page itself.
  if (CLUSTER !== 'dev' && !isJoinRatRaceHost(req)) {
    return {
      redirect: {
        destination:
          CLUSTER === 'stage'
            ? 'https://stage.joinratrace.com'
            : 'https://joinratrace.com',
        permanent: true,
      },
    };
  }

  setResponseHeaders({
    req,
    res,
    maxAge: 86400,
    contentIDs: [{ type: 'quiz', id: 'rat-race-landing' }],
  });

  const policyBasePath = getRatRacePolicyBasePath(req);

  return { props: { policyBasePath } };
}

export default function RatRacePage({ policyBasePath }) {
  return (
    <TrackingContext.Provider value={PAGE_INFO}>
      <RatRacePageContent policyBasePath={policyBasePath} />
    </TrackingContext.Provider>
  );
}
